export const THEME_MODES = {
  LIGHT: 'light',
  DARK: 'dark'
}
